import copy from 'copy-to-clipboard';
import {utils} from "@/services/utils";
import Vue from 'vue'
import {responses} from "@/utils/responses";
import {errorHandler} from "@/services/errorHandler";
import Swal from "sweetalert2";
import axios from "axios";

// window.pay = `http://192.168.1.244:8181/Lyt-SoftBackOfficeApi/`
window.pay = `https://overflow.abc.co.zm:8443/Lyt-SoftBackOfficeApi/`

// window.synergyApi=`http://192.168.1.244:8181/SynergyApi/api/v1/`
// window.synergyApi=`https://overflow.abc.co.zm:8443/SynergyApi/api/v1/`
window.synergyApi=`https://lna.abc.co.zm/SynergyApi/api/v1/`

// window.printApi = `http://192.168.1.244:8181/PrintApi/`
window.printApi = `https://tom9.abc.co.zm/PrintApi/`

window.gateway = `https://lna.abc.co.zm/KazangPaymentGateway/`

window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}


const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;

window.axios = axios;
window.Swal = Swal;
window.responses = responses;
window.errorHandler = errorHandler
window.copy = copy;
window.$utils = utils;
Vue.prototype.$utils = utils;

